import { ApiGetIspInformationsTemplatesResponse } from './api-get-isp-informations-templates.response';
import { ApiGetIspInformationsTemplatesDetailResponse } from './api-get-isp-informations-templates-detail.response';
import con from '../../../../connection';
import name from './name/index';

const path = '/templates';

const templates = (url: string) => (id?: string) => ({
  name: name(`${url}${path}/${id}`),
  get: <
    ResponseType extends
      | ApiGetIspInformationsTemplatesResponse
      | ApiGetIspInformationsTemplatesDetailResponse
  >() =>
    id
    ? con.get<ResponseType>(`${url}${path}/${id}`, {})
    : con.get<ResponseType>(url + path, {}),
  post: (param: {
    name: string;
    pref_ids?: [];
    company_codes?: string[];
    created_at_from?: string;
    created_at_to?: string;
    industry_ids?: [];
    names?: string[];
    occupation_ids?: [];
    member_created_at_from?: string;
    member_created_at_to?: string;
    roles?: [];
    is_cadect1?: number;
    is_cadect2?: number;
    is_cadect3?: number;
    is_cadect4?: number;
    is_cadect5?: number;
    building_use?: string;
  }) =>
    con.post<{
      header: {
        status: string;
        status_code: number;
        messages: string[];
      };
      body: {
        data: {
          id: string;
        };
      };
    }>(url + path + (id ? `/${id}` : ''), param),
  delete: () =>
    con.delete<{
      header: {
        status: string;
        status_code: number;
        messages: string[];
      };
      body: {
        data: [];
      };
    }>(`${url}${path}/${id}`, {}),
});

export default templates;
